import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { Adviser, DatatableRootObject, DataTablesResponse, PagedList, UploadDataResult } from '../interfaces/interfaces.index';
import { NewAdviser } from '../interfaces/new_adviser';
import { UploadFile } from '../shared/upload/upload.component';
import { ConcessionaireAdviser, PetitionUserIds } from '../interfaces/adviser';
import { Petition } from '../interfaces/petition';
import { BehaviorSubject } from 'rxjs';
const URL = `${URL_SERVICIOS}adviser`;
const URL_CON = `${URL}/concessionaire`;

@Injectable({
  providedIn: 'root'
})
export class AdviserService {

  redirectToProcess: BehaviorSubject<PetitionUserIds> = new BehaviorSubject(null);

  constructor(private http: HttpClient) { }

  addAdviserStorage = (id: number) => sessionStorage.setItem('UserId', JSON.stringify(id));

  addAdviserInfoStore = (adviser: ConcessionaireAdviser) => sessionStorage.setItem('Adviser', JSON.stringify(adviser));

  getAdviserStore = () => sessionStorage.getItem('UserId');

  getAdviserInfoStore = () => sessionStorage.getItem('Adviser');

  getAdviserConcessionaire = (advisorId: number) =>
    this.http.get<ConcessionaireAdviser>(`${URL_SERVICIOS}Concessionaire/GetConcessionaireAdviser?UserId=${advisorId}`, HTTP_OPTIONS)

  getAllAdviser = () => this.http.get<PagedList<Adviser>>(URL);

  getAllAdviserByConcessionarie = (id: number) => this.http.get<Adviser[]>(`${URL_CON}/${id}`, HTTP_OPTIONS);

  getAdviser = (id: number) => this.http.get<Adviser>(`${URL}/${id}`);

  get_Adviser = (id: number) => this.http.get<NewAdviser>(`${URL}/${id}`);

  addAdviser = (data: Adviser) => this.http.post<Adviser>(URL, JSON.stringify(data), HTTP_OPTIONS);

  add_Adviser = (data: NewAdviser) => this.http.post<NewAdviser>(URL, JSON.stringify(data), HTTP_OPTIONS);

  putAdviser = (id: number, data: NewAdviser) => this.http.put<NewAdviser>(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);

  deleteAdviser = (id: number) => this.http.delete(`${URL}/${id}`, HTTP_OPTIONS);

  massiveAdviser = (file: UploadFile) => this.http.post<UploadDataResult>(`${URL}/file`, file, HTTP_OPTIONS);

  getAdviserByUserId = (id: number) => this.http.get<ConcessionaireAdviser[]>(`${URL}/user/${id}`, HTTP_OPTIONS);

  getVehicleDeliveryUserList = (id: number) => this.http.get(`${URL}/vehicleDeliveryUserList/${id}`, HTTP_OPTIONS);

  getAdvisersDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Adviser>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);
}
